var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-title',{staticClass:"mb-1"},[_vm._v(" แสดงประเภทสินค้า ")]),_c('vue-apex-charts',{attrs:{"type":"donut","height":"350","options":_vm.donutChart.chartOptions,"series":_vm.donutChart.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }